import type { IconSvgObject } from './types';

const Xls02Icon: IconSvgObject = [
  ["path", { d: "M13.5 13.9998V18.9998H15.5M8 14L9.5 16.5M9.5 16.5L11 19M9.5 16.5L11 14M9.5 16.5L8 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 14H18V16.5H20.5V19H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19.5 22H5.5C4.39543 22 3.5 21.1046 3.5 20L3.5 4C3.5 2.89543 4.39543 2 5.5 2H12.5L19.5 9V11M19 9H14.498C13.3935 9 12.498 8.10457 12.498 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Xls02Icon;
